@if (isNoto()) {
  <span
    class="gs-icon__noto"
    [class.gs-icon__noto--dimmed]="dimmed()"
    [style.font-size.em]="scale()"
    [innerHTML]="notoSvg()"
  ></span>
} @else if (faRef() | renderIcon; as definition) {
  <fa-icon [icon]="definition" [size]="size()" />
}
